export default "__VITE_ASSET__DECvUplj__"